import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PackingList } from '../components/PackingList';
import './PackingPage.css';

const PackingPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) return null;

  return (
    <div className="packing-page">
      <header className="packing-page__header">
        <button className="packing-page__back" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
        </button>
        <h1 className="packing-page__title">Packing List</h1>
      </header>
      <div className="packing-page__body">
        <PackingList itineraryId={parseInt(id, 10)} />
      </div>
    </div>
  );
};

export default PackingPage;
